<template>
    <div id="modal-identity-bug" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="d-flex mb-3">
                        <div class="pt-2 text-nowrap">書類不備理由</div>
                        <div class="flex-fill pl-2">
                            <select v-model.trim="reasonS" class="form-control">
                                <option value="">-- 選択 --</option>
                                <option value="画像またはPDFの不鮮明および反射している">画像またはPDFの不鮮明および反射している</option>
                                <option value="書類の有効期限切れ">書類の有効期限切れ</option>
                                <option value="書類の名前が登録情報と異なる">書類の名前が登録情報と異なる</option>
                                <option value="書類の住所が登録情報と異なる">書類の住所が登録情報と異なる</option>
                                <option value="書類に氏名または住所の記載がない">書類に氏名または住所の記載がない</option>
                                <option value="端等が切れており、書類全体が確認できない">端等が切れており、書類全体が確認できない</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-2">
                        <span>
                            <span class="text-muted">({{this.reasonLength}}/100)</span>
                        </span>
                    </div>
                    <div>
                        <textarea v-model.trim="reason" class="form-control" rows="2" spellcheck=false  maxlength="200"></textarea>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="btnOk" :disabled="disableBtn">
                        送信する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                reasonS: "",
                reason: "",
            }
        },
        watch: {
            reasonS (val) {
                this.reason = this.reasonS
            },
            getIdentityNgStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            disableBtn () {
                if (this.reason == '' || this.reason == null) {
                    return true
                } else {
                    return false
                }
            },
            reasonLength () {
                return this.reason.length
            },
            ...mapGetters(['getIdentityNgStatus'])
        },
        methods: {
            btnOk () {
                this.$store.dispatch('identityNg', {
                    userId: this.$route.params.userId,
                    reason: this.reason
                })
            },
            openThis () {
                this.resetThis()
                $('#modal-identity-bug').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-identity-bug').modal('hide')
            },
            resetThis () {
                this.reasonS = ""
                this.reason = ""
            }
        }
    }
</script>

<style>

</style>
